"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _Doughnutchart = _interopRequireDefault(require("./Doughnutchart"));
var _doughnutdata = _interopRequireDefault(require("./doughnutdata.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const defaultgraphData = {
  labels: [],
  datasets: [{
    label: 'Data',
    backgroundColor: [],
    data: [],
    borderWidth: 2
  }]
};
function App(_ref) {
  let {
    dataFromTextArea,
    json,
    graphstyle
  } = _ref;
  const chartData = defaultgraphData;
  const jsonDataa = JSON.stringify(_doughnutdata.default);
  const [inputText, setInputText] = (0, _react.useState)(defaultgraphData);
  const jsonProp = JSON.stringify(json);
  (0, _react.useEffect)(() => {
    if (JSON.stringify(json) == "" && _doughnutdata.default) {
      if (dataFromTextArea && isJsonString(dataFromTextArea)) {
        let dataObj = handleJsonData(JSON.parse(dataFromTextArea));
        const graphData = {
          labels: dataObj.labels,
          datasets: [{
            backgroundColor: dataObj.backgroundColor,
            data: dataObj.data,
            borderWidth: 2
          }]
        };
        setInputText(graphData);
      } else if (isJsonString(jsonDataa)) {
        let dataObj = handleJsonData(JSON.parse(jsonDataa));
        const graphData = {
          labels: dataObj.labels,
          datasets: [{
            backgroundColor: dataObj.backgroundColor,
            data: dataObj.data,
            borderWidth: 2
          }]
        };
        setInputText(graphData);
      }
    } else {
      let dataObj = handleJsonData(JSON.parse(jsonProp));
      const graphData = {
        labels: dataObj.labels,
        datasets: [{
          backgroundColor: dataObj.backgroundColor,
          data: dataObj.data,
          borderWidth: 2
        }]
      };
      setInputText(graphData);
    }
  }, [dataFromTextArea, json, jsonDataa]);
  console.log('inputText', inputText);
  console.log('chartData', chartData);
  console.log('dataFromTextArea', dataFromTextArea);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mac-valign"
  }, /*#__PURE__*/_react.default.createElement(_Doughnutchart.default, {
    data: inputText,
    options: options,
    style: graphstyle
  }));
}
var _default = exports.default = App;
const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      display: true,
      position: 'bottom'
    }
  }
};
function handleJsonData(chartData) {
  let labels = chartData.map(item => item.label);
  let data = chartData.map(item => item.value);
  let backgroundColor = chartData.map(item => item.color);
  return {
    labels,
    data,
    backgroundColor
  };
}
function isJsonString(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}